"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.SIZE_BYTE = 1;
    Constants.SIZE_INT32 = 4;
    Constants.SIZE_DOUBLE = 8;
    Constants.SIZE_POINT = 16;
    Constants.SIZE_GEOM_TYPE = 4;
    Constants.TYPE_FEATURE = 'Feature';
    Constants.TYPE_FEATURE_COLLECTION = 'FeatureCollection';
    return Constants;
}());
exports.default = Constants;
